export const isNil = val => val === undefined || val === null;
export const isObject = val => !isNil(val) && typeof val === 'object';
export const isString = val => !isNil(val) && typeof val === 'string';
